export default "<img src=\"{{ imagePath }} \" alt=\"Logo des Versicherers\" />";